export interface Topic {
  id: string;
  title: string;
  subtitle: string;
  cover: string;
  count: number;
  tags: string[];
}

export const topics: Topic[] = [
  {
    id: 't1',
    title: '年度剧集大盘点',
    subtitle: '从现象级古装到现实主义佳作，回顾这一年真正被记住的剧集。',
    cover:
      'https://readdy.ai/api/search-image?query=Stylized%20illustration%20of%20a%20stack%20of%20glowing%20drama%20posters%20in%20a%20dark%20room%2C%20warm%20orange%20light%2C%20editorial%20year%20review%20mood%2C%20charcoal%20and%20amber%20palette%2C%20soft%20grain%2C%20no%20text&width=800&height=500&seq=topic-01&orientation=landscape',
    count: 12,
    tags: ['剧集', '盘点', '口碑'],
  },
  {
    id: 't2',
    title: '演唱会经济观察',
    subtitle: '巡演官宣、门票秒罄、实名制升级，现场演出市场为何持续火爆。',
    cover:
      'https://readdy.ai/api/search-image?query=Stylized%20illustration%20of%20a%20stadium%20concert%20with%20thousands%20of%20fans%20and%20warm%20orange%20light%20sticks%2C%20epic%20live%20music%20mood%2C%20charcoal%20and%20amber%20palette%2C%20soft%20grain%2C%20no%20text&width=800&height=500&seq=topic-02&orientation=landscape',
    count: 9,
    tags: ['演出', '巡演', '市场'],
  },
  {
    id: 't3',
    title: '短剧风暴进行时',
    subtitle: '十分钟一集的爆款逻辑，正在改写内容行业的节奏与想象力。',
    cover:
      'https://readdy.ai/api/search-image?query=Stylized%20illustration%20of%20a%20burst%20of%20vertical%20video%20frames%20exploding%20out%20of%20a%20phone%2C%20warm%20orange%20energy%2C%20short%20drama%20boom%20mood%2C%20charcoal%20and%20amber%20palette%2C%20soft%20grain%2C%20no%20text&width=800&height=500&seq=topic-03&orientation=landscape',
    count: 8,
    tags: ['短剧', '爆款', '内容'],
  },
];